<template>
  <main class="main">
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-0 mb-lg-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/presentation">Presentazioni</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <LoadedComponent :loading="loading" />
    <div class="page-content">
      <div class="container">
        <div class="mb-2" v-if="successMessage">
          <AlertComponent :message="successMessage" :alert-type="'success'" />
        </div>

        <div class="row">
          <FilterComponent :activities="activities" @setActivities="setActivities" :patologies="patologies"
            :categoryMedicals="categoryMedicals" :anatomicalDistricts="anatomicalDistricts"
            v-on:update:filteredPatologies="updatePatologies"
            v-on:update:filteredCategoryMedicals="updateCategoryMedicals"
            v-on:update:filteredAnatomicalDistricts="updateAnatomicalDistricts" category="4"
            :permission="permission.create_presentazioni"></FilterComponent>

          <div class="col-lg-9">
            <div class="products mb-3">
              <div class="row justify-content-center" v-if="activities.length > 0">
                <div class="col-12 col-md-4 col-lg-4 col-xl-3" v-for="presentation in activities"
                  :key="presentation.id">
                  <router-link :to="getRoute(presentation.slug)">
                    <div class="product product-7 text-center">
                      <figure class="product-media">

                        <div v-if="presentation.cover != null">
                          <div v-if="
                            presentation.cover.type_file == 'jpg' ||
                            presentation.cover.type_file == 'png' ||
                            presentation.cover.type_file == 'jpeg'
                          ">
                            <img :src="presentation.cover.path" alt="Copertina biblioteca" class="img-fluid" />
                          </div>
                          <div v-else-if="presentation.cover.type_file == 'pdf'">
                            <div class="embed-responsive embed-responsive-16by9 center-block">
                              <iframe :src="presentation.cover.path">Contenuto</iframe>
                              *
                            </div>
                          </div>
                          <div v-else-if="presentation.cover.type_file == 'mp4'">
                            <video-component :options="getOptons(presentation.cover.path)"></video-component>
                          </div>

                          <div v-else>
                            <img
                              src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                              alt="image desc" />
                          </div>
                        </div>

                        <div v-else>
                          <img
                            src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                            alt="image desc" />
                        </div>

                      </figure>
                      <div class="product-body">
                        <div class="product-cat">
                          By {{ presentation.author }}
                        </div>
                        <!-- End .product-cat -->
                        <h3 class="product-title">
                          <router-link :to="getRoute(presentation.slug)">{{
                            presentation.name
                            }}</router-link>
                        </h3>
                        <!-- End .product-title -->
                        <div class="product-price">
                          Il {{ presentation.publish_date }}

                        </div>
                        <!-- End .product-price -->
                      </div>
                      <!-- End .product-body -->
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="row justify-content-center" v-else>
                <p>Nessun risultato</p>
              </div>
            </div>
            <nav aria-label="Page navigation"></nav>
          </div>

          <!-- End .col-lg-3 -->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import { useAuth } from "@/stores/auth.js";
import AlertComponent from "@/components/AlertComponent.vue";
import LoadedComponent from "@/components/LoadedComponent.vue";
import VideoComponent from "@/components/VideoComponent.vue";
import FilterComponent from "@/components/FilterComponent.vue";
export default {
  name: "LibraryPage",
  components: {
    AlertComponent,
    LoadedComponent,
    VideoComponent,
    FilterComponent,
  },
  props: {},
  data() {
    return {
      permission: {},
      successMessage: "",
      loading: true,
      errors: [],
      activities: [],
      originalActivities: [],
      patologies: [],
      categoryMedicals: [],
      anatomicalDistricts: [],
      filteredPatologies: [],
      filteredCategoryMedicals: [],
      filteredAnatomicalDistricts: [],
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("successMessagePresentation");

    localStorage.removeItem("successMessagePresentation");
    this.getPresentation();
    this.loadPermission();
    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
  created() { },
  methods: {
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        preload: false,
        width: "200",
        height: "110",

        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    getPresentation() {
      httpauth
        .get("/presentations")
        .then((response) => {
          this.originalActivities = response.data.data;
          this.activities = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    getRoute(slug) {
      if (this.permission.show_presentazioni)
      {
        return "/presentation/show/" + slug;
      }
      return "#";
    },
    setActivities(value) {
      this.activities = value;
    },
    async loadPermission() {
      await httpservices
        .checkPermission(1, "presentazioni", "create_presentazioni")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updatePatologies(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.patology_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.patologies);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.patology_id)
        );
      }
    },
    updateCategoryMedicals(selectedCategories) {
      console.log(selectedCategories);
    },
    updateAnatomicalDistricts(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.anatomical_district_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.anatomicalDistricts);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.anatomical_district_id)
        );
      }
    },
    mappingOriginalArray(originalArray) {
      return originalArray.map((item) => item.id);
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedicals = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistricts = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>